import { CSSProperties } from 'react'

const styles: { input: CSSProperties } = {
  input: {
    outline: 0,
    width: '100%',
    border: 0,
    padding: 12,
    boxSizing: 'border-box',
    fontSize: 18,
    backgroundColor: '#5b5b5b',
    color: 'white',
  },
}

export default styles
